/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Highlight_Settings_Playbar_DescriptionInputs */

const en_highlight_settings_playbar_description = /** @type {(inputs: Highlight_Settings_Playbar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose how the playbar is positioned and behaves on pages`)
};

const es_highlight_settings_playbar_description = /** @type {(inputs: Highlight_Settings_Playbar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige dónde aparece y cómo se comporta la barra`)
};

/**
* | output |
* | --- |
* | "Choose how the playbar is positioned and behaves on pages" |
*
* @param {Highlight_Settings_Playbar_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const highlight_settings_playbar_description = /** @type {((inputs?: Highlight_Settings_Playbar_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Highlight_Settings_Playbar_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_highlight_settings_playbar_description(inputs)
	return en_highlight_settings_playbar_description(inputs)
});